<style>
.MeasurementHistory .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.MeasurementHistory .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.MeasurementHistory .table__container--panel p {
  font-size: 12px;
}
.MeasurementHistory .table__container--filter {
  font-size: 12px;
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
}
</style>

<template>
  <v-layout row fill-height wrap class="MeasurementHistory">
    <ExportTableData ref="pobierz" :column-defs="columnDefs" :grid-options="gridOptions"></ExportTableData>
    <v-layout class="table__container--panel" wrap>
      <v-icon
        style="padding-left: 10px"
        title="Pobierz"
        @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
      >description</v-icon>
      <v-layout align-right justify-end>
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    tableTitle: "measurementHistoryTable",
    filter: "",
    inspectionsTaskFiltered: undefined,
    numberAll: 0,
    numberFiltered: 0
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.rowData,
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        onFilterModified: this.filteredNumber,
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        rowSelection: "multiple",
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  beforeMount() {
    this.columnDefs = [
      { headerName: "Alarm", field: "alarmed" },
      { headerName: "Zgłoszono", field: "reported" },
      { headerName: "Potwierdzono", field: "confirmed" },
      { headerName: "Zamknięto", field: "closed" }
    ];
    this.rowData = [
      {
        alarmed: "2018.11.08 09:58",
        reported: "2018.11.08 09:58",
        confirmed: "2018.11.08 09:58",
        closed: "2018.11.08 09:58"
      }
    ];

    this.numberAll = this.rowData.length;
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if (localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if (columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/MeasurementHistory.vue